import React from 'react';
import { CircularLoader, Icon } from 'UI';
import cn from 'classnames';
export default function ReloadButton(props) {
    var loading = props.loading, onClick = props.onClick, _a = props.iconSize, iconSize = _a === void 0 ? "14" : _a, _b = props.iconName, iconName = _b === void 0 ? "sync-alt" : _b, _c = props.className, className = _c === void 0 ? '' : _c;
    return (React.createElement("div", { className: cn("ml-4 h-5 w-6 flex items-center justify-center", className), onClick: onClick }, loading ? React.createElement(CircularLoader, { className: "ml-1" }) : React.createElement(Icon, { name: iconName, size: iconSize })));
}
